var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddCard = function SvgAddCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text)",
    d: "M.5 3A2.5 2.5 0 0 1 3 .5h34A2.5 2.5 0 0 1 39.5 3v20a2.5 2.5 0 0 1-2.5 2.5H3A2.5 2.5 0 0 1 .5 23z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-text)",
    d: "M14.69 13.151c0 .14.12.26.261.26h4.78v4.734c0 .14.121.26.262.26a.26.26 0 0 0 .262-.26v-4.734h4.787c.141 0 .262-.12.262-.26a.26.26 0 0 0-.262-.26h-4.787v-4.74a.26.26 0 0 0-.262-.26.265.265 0 0 0-.261.26v4.74h-4.78a.26.26 0 0 0-.262.26"
  })));
};
export default SvgAddCard;